"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionResourceType = exports.PermissionAction = exports.PermissionResourceQualifier = exports.PermissionResourceAlias = void 0;
/**
 * An alias to a resource, e.g. all resources, or owned resources.
 */
var PermissionResourceAlias;
(function (PermissionResourceAlias) {
    /**
     * Access over all resources of this type.
     */
    PermissionResourceAlias["All"] = "*";
    /**
     * Access to all resources that the context owns.
     */
    PermissionResourceAlias["Own"] = "own";
})(PermissionResourceAlias = exports.PermissionResourceAlias || (exports.PermissionResourceAlias = {}));
/**
 * Qualifies what type of Identifier
 */
var PermissionResourceQualifier;
(function (PermissionResourceQualifier) {
    PermissionResourceQualifier["Role"] = "role";
    PermissionResourceQualifier["User"] = "user";
})(PermissionResourceQualifier = exports.PermissionResourceQualifier || (exports.PermissionResourceQualifier = {}));
var PermissionAction;
(function (PermissionAction) {
    PermissionAction["All"] = "*";
    PermissionAction["Access"] = "access";
    PermissionAction["Associate"] = "associate";
    PermissionAction["View"] = "view";
    PermissionAction["Create"] = "create";
    PermissionAction["Submit"] = "submit";
    PermissionAction["Edit"] = "edit";
    PermissionAction["Manage"] = "manage";
    PermissionAction["Delete"] = "delete";
    PermissionAction["Decline"] = "decline";
    PermissionAction["Reset"] = "reset";
})(PermissionAction = exports.PermissionAction || (exports.PermissionAction = {}));
var PermissionResourceType;
(function (PermissionResourceType) {
    PermissionResourceType["All"] = "*";
    PermissionResourceType["AboutTab"] = "about_tab";
    PermissionResourceType["AdmissionResult"] = "admission_result";
    PermissionResourceType["Agenda"] = "agenda";
    PermissionResourceType["Alert"] = "alert";
    PermissionResourceType["AnswerSheet"] = "answer_sheet";
    PermissionResourceType["Application"] = "application";
    PermissionResourceType["AskLink"] = "ask_link";
    PermissionResourceType["Availability"] = "availability";
    PermissionResourceType["AvailabilityTab"] = "availability_tab";
    PermissionResourceType["Billing"] = "billing";
    PermissionResourceType["BillingTab"] = "billing_tab";
    PermissionResourceType["BookingOnBehalf"] = "booking_on_behalf";
    PermissionResourceType["Calendar"] = "calendar";
    PermissionResourceType["UserDashboard"] = "user_dashboard";
    PermissionResourceType["CGAReport"] = "cga_report";
    PermissionResourceType["CGAStudentReports"] = "cga_student_progress";
    PermissionResourceType["CollaborativeEditor"] = "collaborative_editor";
    PermissionResourceType["Consent"] = "consent";
    PermissionResourceType["Contact"] = "contact";
    PermissionResourceType["Contract"] = "contract";
    PermissionResourceType["ContractThread"] = "contract_thread";
    PermissionResourceType["CommunityTab"] = "community_tab";
    PermissionResourceType["CrimsonConnectLink"] = "crimson_connect_link";
    PermissionResourceType["DevTools"] = "dev_tools";
    PermissionResourceType["Ecl"] = "ecl";
    PermissionResourceType["EclSearchLink"] = "ecl_search_link";
    PermissionResourceType["EssayFolder"] = "essay_folder";
    PermissionResourceType["ExamPrep"] = "exam_prep";
    PermissionResourceType["ExamPrepAvailability"] = "exam_prep_availability";
    PermissionResourceType["ExamPrepTab"] = "exam_prep_tab";
    PermissionResourceType["FeatureStable"] = "feature_stable";
    PermissionResourceType["FeatureTest"] = "feature_test";
    PermissionResourceType["File"] = "file";
    PermissionResourceType["Grade"] = "grade";
    PermissionResourceType["Hexaco"] = "hexaco";
    PermissionResourceType["HookStatement"] = "hook_statement";
    PermissionResourceType["HubLink"] = "hub_link";
    PermissionResourceType["Invoice"] = "invoice";
    PermissionResourceType["InvoiceList"] = "invoice_list";
    PermissionResourceType["InvoicePaid"] = "invoice_paid";
    PermissionResourceType["KeyContact"] = "key_contact";
    PermissionResourceType["LessonDetails"] = "lesson_details";
    PermissionResourceType["LessonList"] = "lesson_list";
    PermissionResourceType["LessonReport"] = "lesson_report";
    PermissionResourceType["Message"] = "message";
    PermissionResourceType["OtherSessionsTab"] = "other_sessions_tab";
    PermissionResourceType["OurPeople"] = "our_people";
    PermissionResourceType["Package"] = "package";
    PermissionResourceType["PackageSubject"] = "package_subject";
    PermissionResourceType["PackageTab"] = "package_tab";
    PermissionResourceType["PreferredName"] = "preferred_name";
    PermissionResourceType["PreferredPronoun"] = "preferred_pronoun";
    PermissionResourceType["ProgressReport"] = "progress_report";
    PermissionResourceType["ProgressReportTab"] = "progress_report_tab";
    PermissionResourceType["RatingSentiment"] = "rating_sentiment";
    PermissionResourceType["RatingTab"] = "rating_tab";
    PermissionResourceType["RecordingConsent"] = "recording_consent";
    PermissionResourceType["RelatedCalendar"] = "related_calendar";
    PermissionResourceType["RelatedStudent"] = "related_student";
    PermissionResourceType["RelationshipThread"] = "relationship_thread";
    PermissionResourceType["Resource"] = "resource";
    PermissionResourceType["ResourceTab"] = "resource_tab";
    PermissionResourceType["Roadmap"] = "roadmap";
    PermissionResourceType["RoadmapElement"] = "roadmap_element";
    PermissionResourceType["RoadmapTemplate"] = "roadmap_template";
    PermissionResourceType["SessionNotes"] = "session_notes";
    PermissionResourceType["SessionReport"] = "session_report";
    PermissionResourceType["SessionResource"] = "session_resource";
    PermissionResourceType["SessionSummary"] = "session_summary";
    PermissionResourceType["SpyMessage"] = "spy_message";
    PermissionResourceType["StrategistFeedback"] = "strategist_feedback";
    PermissionResourceType["StudentContractStatus"] = "student_contract_status";
    PermissionResourceType["StudentRegularQuestions"] = "student_regular_questions";
    PermissionResourceType["StudentInfoNotes"] = "student_info_notes";
    PermissionResourceType["StudentInterests"] = "student_interests";
    PermissionResourceType["StudentType"] = "student_type";
    PermissionResourceType["StudentsTab"] = "students_tab";
    PermissionResourceType["Subject"] = "subject";
    PermissionResourceType["SubjectCategory"] = "subject_category";
    PermissionResourceType["SubjectTutor"] = "subject_tutor";
    PermissionResourceType["SubjectsTab"] = "subjects_tab";
    PermissionResourceType["Task"] = "task";
    PermissionResourceType["Team"] = "team";
    PermissionResourceType["TutorInfoNotes"] = "tutor_info_notes";
    PermissionResourceType["UnsubscribeLink"] = "unsubscribe_link";
    PermissionResourceType["User"] = "user";
    PermissionResourceType["UserAuth"] = "user_auth";
    PermissionResourceType["UserEducoRelationship"] = "user_educo_relationship";
    PermissionResourceType["UserHeadTutorRelationship"] = "user_head_tutor_relationship";
    PermissionResourceType["UserProfile"] = "user_profile";
    PermissionResourceType["UserRelationship"] = "user_relationship";
    PermissionResourceType["UserReviewerRelationship"] = "user_reviewer_relationship";
    PermissionResourceType["UserStrategistRelationship"] = "user_strategist_relationship";
    PermissionResourceType["ZoomMeeting"] = "zoom_meeting";
    PermissionResourceType["ZoomUser"] = "zoom_user";
    PermissionResourceType["SessionRecording"] = "session_recording";
})(PermissionResourceType = exports.PermissionResourceType || (exports.PermissionResourceType = {}));
//# sourceMappingURL=types.js.map